export class SpringDatatablePagination {

    rowData:any = [];
    currentPage:number = 0; 
    totalPages:number = 0; 
    totalElements:number = 0; 
    tableLimit:number = 0;
    

	constructor() {

	}

}